const common = {
  // Navigation
  "nav.home": "Home",
  "nav.capabilities": "Capabilities",
  "nav.architecture": "Architecture",
  "nav.consensus": "Consensus",
  "nav.developers": "Developers",
  "nav.rwa": "RWA",
  "nav.rmind": "R-Mind",
  "nav.docs": "Docs",
  "nav.launch": "Launch App",

  // Hero Section
  "hero.badge": "Next-Gen RWA Infrastructure",
  "hero.title": "Building the Future of Real-World Assets",
  "hero.subtitle": "RoonChain is a high-performance Layer 1 blockchain purpose-built for Real-World Asset tokenization, enabling seamless on-chain settlement and cross-domain collaboration",
  "hero.cta.start": "Explore More",
  "hero.cta.docs": "Whitepaper",
  "hero.card.block": "Block",
  "hero.card.gas": "Gas",

  // Core Capabilities
  "core.title": "Core Capabilities",
  "core.subtitle": "Enterprise-grade infrastructure optimized for complex RWA scenarios and real-world on-chain collaboration",
  "core.performance.title": "High Performance",
  "core.performance.desc": "Optimized for high-frequency asset settlement with sustained throughput and fast finality under real-world load",
  "core.performance.feature1": "Parallel transaction processing engine",
  "core.performance.feature2": "Optimized state storage",
  "core.performance.feature3": "Instant finality confirmation",
  "core.modular.title": "Modular Architecture",
  "core.modular.consensus": "Consensus Layer",
  "core.modular.consensus.desc": "Network security and state consistency",
  "core.modular.execution": "Execution Layer",
  "core.modular.execution.desc": "High-concurrency transactions",
  "core.modular.data": "Data Layer",
  "core.modular.data.desc": "Verifiable storage with audit support",
  "core.crosschain.title": "Cross-Chain Interop",
  "core.crosschain.desc": "Multi-chain asset and data collaboration connecting ecosystems and enhancing RWA liquidity",
  "core.rwa.title": "RWA-Native Design",
  "core.rwa.desc": "Built for multi-party collaboration, state transitions, and structured equity expression in complex asset scenarios",
  "core.rwa.tag1": "Multi-Party",
  "core.rwa.tag2": "Structured",
  "core.rwa.tag3": "Compliant",
  "core.security.title": "Decentralized Security",
  "core.security.desc": "Validator-first security model ensuring on-chain state verifiability and long-term operational stability",

  // RWA Applications
  "rwa.title": "RWA Applications",
  "rwa.subtitle": "Universal technical foundation for diverse real-world asset forms and complex collaboration mechanisms",
  "rwa.realestate": "Real Estate",
  "rwa.realestate.desc": "Property income rights, long-term leases, and structured equity tokenization",
  "rwa.energy": "Energy & Resources",
  "rwa.energy.desc": "Energy revenue structures, mineral rights, and long-cycle project financing",
  "rwa.commodity": "Commodities",
  "rwa.commodity.desc": "Commodity settlement and supply chain income rights tokenization",
  "rwa.structured": "Structured Yields",
  "rwa.structured.desc": "Multi-source yield portfolios and sustainable asset models",
  "rwa.onchain.title": "On-Chain Settlement",
  "rwa.onchain.desc": "Complete asset lifecycle management from issuance to settlement, all recorded on-chain for transparency",
  "rwa.onchain.note": "Supporting multiple asset types with standardized tokenization protocols",
  "rwa.onchain.tag1": "Tokenization",
  "rwa.onchain.tag2": "Settlement",
  "rwa.onchain.tag3": "Lifecycle",
  "rwa.compliance.title": "Compliance Framework",
  "rwa.compliance.desc": "Built-in regulatory compliance tools supporting KYC/AML requirements across jurisdictions",
  "rwa.compliance.note": "Flexible compliance modules adaptable to different regulatory environments",
  "rwa.compliance.tag1": "KYC/AML",
  "rwa.compliance.tag2": "Cross-Jurisdiction",
  "rwa.compliance.tag3": "Modular",

  // Technical Architecture
  "tech.badge": "ARCHITECTURE",
  "tech.title": "Layered Modular Architecture",
  "tech.desc1": "RoonChain adopts a layered modular design, decoupling consensus, execution, and data layers for independent scaling and upgrades.",
  "tech.desc2": "This architecture ensures system stability while providing flexibility for future technological evolution.",
  "tech.uptime": "Network Uptime",
  "tech.uptime.desc": "Enterprise-grade reliability with redundant infrastructure",
  "tech.finality": "Block Finality",
  "tech.finality.desc": "Fast confirmation for real-time settlement needs",
  "tech.cta": "View Technical Docs",
  "tech.tps": "TPS Throughput",
  "tech.nodes": "Validator Nodes",
  "tech.uptime.label": "Uptime",
  "tech.evm": "EVM Compatible",
  "tech.layered.title": "Layered Architecture",
  "tech.layered.layers": "Layers",
  "tech.layered.tag1": "Consensus",
  "tech.layered.tag2": "Execution",
  "tech.layered.tag3": "Data",
  "tech.parallel.title": "Parallel Processing",
  "tech.parallel.desc": "Efficient parallel transaction execution",
  "tech.optimized.title": "Optimized Storage",
  "tech.optimized.desc": "Optimized state tree structure",
  "tech.zerotrust.title": "Zero-Trust Security",
  "tech.zerotrust.desc": "Zero-trust security model",
  "tech.explore.title": "Explore Complete Technical Documentation",
  "tech.explore.desc": "Learn about RoonChain's technical details and implementation principles",

  // Developer Support
  "dev.title": "Developer Support",
  "dev.subtitle": "Complete toolkit for building production-ready RWA applications with comprehensive documentation",
  "dev.evm.title": "EVM Compatible",
  "dev.evm.desc": "Full support for Solidity and Ethereum ecosystem tooling",
  "dev.tools.title": "Developer Tools",
  "dev.tools.desc": "End-to-end development, testing, and deployment workflows",
  "dev.tools.rpc": "RPC Node",
  "dev.tools.explorer": "Explorer",
  "dev.tools.api": "API",
  "dev.tools.sdk": "SDK",
  "dev.docs.title": "Documentation",
  "dev.docs.desc": "Comprehensive and continuously updated technical docs",
  "dev.docs.quickstart": "Quick Start",
  "dev.docs.quickstart.desc": "Get started in minutes",
  "dev.docs.api": "API Reference",
  "dev.docs.api.desc": "Complete API documentation",
  "dev.docs.examples": "Code Examples",
  "dev.docs.examples.desc": "Ready-to-use templates",
  "dev.docs.best": "Best Practices",
  "dev.docs.best.desc": "Production guidelines",
  "dev.cta.title": "Ready to Build?",
  "dev.cta.desc": "Join our developer community and start building on RoonChain today",
  "dev.cta.docs": "Read Docs",
  "dev.cta.github": "GitHub",
  "dev.stats.developers": "Developers",
  "dev.stats.contracts": "Contracts",
  "dev.stats.projects": "Projects",
  "dev.stats.support": "Support",

  // Consensus Section
  "consensus.badge": "CONSENSUS",
  "consensus.title": "Consensus & Security",
  "consensus.subtitle": "Security-first design balancing performance, decentralization, and operational efficiency",
  "consensus.mechanism.title": "Consensus Mechanism",
  "consensus.mechanism.desc1": "Byzantine fault-tolerant consensus ensuring network security",
  "consensus.mechanism.desc2": "Avoiding single points of failure with distributed validation",
  "consensus.mechanism.desc3": "Supporting governance upgrades and protocol evolution",
  "consensus.mechanism.metric": "Network Consensus Rate",
  "consensus.performance.title": "Performance & Scale",
  "consensus.performance.desc1": "Optimized for high-frequency settlement scenarios",
  "consensus.performance.desc2": "Stable transaction processing under peak loads",
  "consensus.performance.desc3": "Horizontal scaling with validator network growth",
  "consensus.performance.tps": "TPS",
  "consensus.performance.confirm": "Confirm Time",
  "consensus.performance.availability": "Uptime",
  "consensus.security.title": "Security Model",
  "consensus.security.desc1": "Resilient against malicious node attacks",
  "consensus.security.desc2": "Network anomaly detection and recovery",
  "consensus.security.desc3": "Off-chain uncertainty handling mechanisms",
  "consensus.security.feature1": "Multi-signature validation",
  "consensus.security.feature2": "Slashing conditions",
  "consensus.security.feature3": "Emergency governance",
  "consensus.evm.title": "EVM Compatibility",
  "consensus.evm.desc1": "Seamless integration with Ethereum ecosystem",
  "consensus.evm.desc2": "Support for existing smart contracts and tools",
  "consensus.evm.desc3": "Familiar development experience for Web3 builders",
  "consensus.crosschain.title": "Cross-Chain Bridge",
  "consensus.crosschain.desc": "Secure asset transfers across multiple blockchain networks with cryptographic verification and decentralized validation.",
  "consensus.crosschain.note": "Supporting major L1 chains and L2 rollups with unified liquidity pools",
  "consensus.crosschain.chains": "Supported Chains",
  "consensus.crosschain.verify": "Verification Rate",

  // R-Mind Section
  "rmind.title": "R-Mind",
  "rmind.subtitle": "AI-Powered Intelligence Layer",
  "rmind.desc1": "R-Mind is the AI intelligence layer of RoonChain, providing smart analysis and automation capabilities.",
  "rmind.desc2": "Enhancing network operations and asset management through machine learning and data analytics.",
  "rmind.ai.title": "AI Intelligence Layer",
  "rmind.ai.feature1": "Real-time asset state assessment",
  "rmind.ai.feature2": "Risk identification and alerts",
  "rmind.ai.feature3": "Intelligent decision support",
  "rmind.analysis.title": "Intelligent Analysis",
  "rmind.analysis.desc": "Asset state assessment, risk identification, and decision support for complex scenarios",
  "rmind.automation.title": "Automated Workflows",
  "rmind.automation.desc": "Rule-based triggers, process execution, and task orchestration for operational efficiency",
  "rmind.rwa.title": "RWA Optimization",
  "rmind.rwa.desc": "Complex asset logic handling, long-term management, and multi-party rule coordination",
  "rmind.principles.title": "Core Principles",
  "rmind.principles.rule": "AI assists but never bypasses rules",
  "rmind.principles.verify": "Critical execution requires on-chain verification",
  "rmind.principles.audit": "All actions are auditable and traceable",
  "rmind.cta": "Explore R-Mind",
  "rmind.security.title": "Security Design",
  "rmind.security.item1": "Sandboxed AI execution",
  "rmind.security.item2": "Human-in-the-loop",
  "rmind.security.item3": "Transparent audit trails",
  "rmind.future.title": "Future Roadmap",
  "rmind.future.desc": "Continuous enhancement of AI capabilities including advanced predictive analytics, natural language interfaces, and autonomous agent frameworks for complex RWA management scenarios.",
  "rmind.stats.models": "AI Models",
  "rmind.stats.data": "Data Processed/Day",
  "rmind.stats.latency": "Response Latency",
  "rmind.stats.accuracy": "Accuracy Rate",

  // Footer
  "footer.newsletter": "Enter your email",
  "footer.tagline1": "Building the Future",
  "footer.tagline2": "of Real-World Assets",
  "footer.network.title": "Network Info",
  "footer.network.name": "Network Name",
  "footer.network.symbol": "Token Symbol",
  "footer.network.chainId": "Chain ID",
  "footer.network.explorer": "Block Explorer",
  "footer.contracts.title": "Contracts",
  "footer.contracts.nodeNft": "Node NFT",
  "footer.links.title": "Quick Links",
  "footer.links.explorer": "Block Explorer",
  "footer.email.title": "Contact Us",
  "footer.email.rwa": "RWA & Enterprise Asset Cooperation",
  "footer.email.tech": "Technical Support & Developer Services",
  "footer.email.biz": "Business Cooperation & Ecosystem Partners",
  "footer.email.legal": "Legal & Compliance Affairs",
  "footer.email.contact": "General Inquiries",
  "footer.protocol": "Protocol",
  "footer.protocol.consensus": "Consensus",
  "footer.protocol.architecture": "Architecture",
  "footer.protocol.security": "Security",
  "footer.developers": "Developers",
  "footer.developers.docs": "Documentation",
  "footer.developers.github": "GitHub",
  "footer.developers.tools": "Tools",
  "footer.resources": "Resources",
  "footer.resources.blog": "Blog",
  "footer.resources.research": "Research",
  "footer.resources.media": "Media Kit",
  "footer.community": "Community",
  "footer.community.discord": "Discord",
  "footer.community.twitter": "Twitter",
  "footer.community.forum": "Forum",
  "footer.copyright": "© 2024 RoonChain. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.description": "RoonChain is a high-performance Layer 1 blockchain purpose-built for Real-World Asset tokenization.",
  "footer.copyright.full": "© RoonChain. All rights reserved.",
  "footer.copyright.content": "All content on this website, including but not limited to text, diagrams, technical descriptions, system designs, layouts, and visual elements, is protected by applicable copyright laws and regulations.",
  "footer.copyright.permission": "No part of this website may be reproduced, distributed, modified, or used for commercial purposes without prior written permission.",
  "footer.copyright.disclaimer": "The information provided on this website is for technical and informational purposes only and does not constitute investment advice, an offer, or a solicitation.",
};

export default common;
